import gql from "graphql-tag";

export default gql`
  mutation inviteUser(
    $accountId: String
    $email: String
    $role: UserRoleTypes
    $app: SSOApps
    $name: String
  ) {
    inviteSSOUser(
      accountId: $accountId
      email: $email
      role: $role
      app: $app
      name: $name
    ) {
      email
      success
      role
      app
      accountName
    }
  }
`;
